/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { runTask } from "ember-lifeline";
import type DmpConsultationContext from "parog-web/contexts/dmp-consultation-context";

interface Args {
  context: DmpConsultationContext;
}

export default class DocumentsRetrieveAccessFormShowComponent extends Component<Args> {
  @tracked showHeaders = false;
  @tracked isGoingBack = false;

  get title(): string {
    return `Consultation d'un document DMP${
      this.args.context.secretConnection ? " - Connexion secrète en cours" : ""
    }`;
  }

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    if (!this.args.context.currentDocumentContent) {
      runTask(this, () => {
        this.args.context.transitionTo();
      });
    }
  }

  @action
  async returnToDocuments() {
    this.isGoingBack = true;
    this.args.context.currentDocumentMetadata = undefined;
    this.args.context.currentDocumentContent = undefined;
    this.args.context.currentState =
      await this.args.context.calculateCurrentState();
  }
}
